import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PrimeIcons } from 'primeng/api';
import { BranchSelectorComponent } from './branch-selector/branch-selector.component';
import { UndoRedoButtonsComponent } from './undo-redo-buttons/undo-redo-buttons.component';
import { WorkspaceSelectorComponent } from './workspace-selector/workspace-selector.component';

@Component({
  selector: 'dt-toolbar',
  imports: [
    BranchSelectorComponent,
    UndoRedoButtonsComponent,
    WorkspaceSelectorComponent,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
  protected readonly PrimeIcons = PrimeIcons;
}
